<template>
  <div>
    <builderall-loader :loading='loading'>
      <!-- Period / Print receipt -->
      <div class="ba-flex ba-flex ba-jc-fe ba-gp-06">
        <div class='ba-box-input ba-md'>
            <div class='ba-info'>
                <div class='ba-info-left'>
                    <label class='ba-label' for='input_id' v-text="t.period"></label>
                    <span class='ba-icon' ba-tooltip-position='top' :ba-tooltip-title='t.select_period_payment_information'>
                        <builderall-icon code='info' />
                    </span>
                </div>
            </div>
            <div class="ba-flex ba-jc-sb ba-gp-06 ">
                <select class='ba-select ba-md' v-model="period">
                    <option v-for="(p, i) in periods" :key="i" v-bind:value="p">{{p}}</option>
                </select>
              <button class='ba-btn ba-sm ba-blue' @click.prevent="print" :disabled="payments.length == 0">
                <builderall-icon code='7535'></builderall-icon>
                  {{ t.print_receipt }}
              </button>
            </div>
        </div>
      </div>

      <!-- Invoices / Resources -->
      <div class="ba-flex ba-jc-sb ba-gp-06 ba-mg-t-1">
        <div class="invoces-container ba-flex ba-gp-1 ba-f-column">

          <div class='ba-card ba-statistics card-period-not-closed' v-if="period == this.getCurrentPeriod()">
            <div class='ba-top'>
                <span class='ba-icon'>
                    <builderall-icon code='info' />
                </span>
                <span class='ba-title'>{{ t.billing_not_closed_for_period }}</span>
            </div>
        </div>

          <div class='ba-card' v-if="payments.length == 0" style="height: 100%">
            <div class='ba-top'>
                <span class='ba-title' v-text="t.payments"></span>
            </div>
            <span v-text="t.no_information_payments_on_period"></span>
          </div>


          <div class='ba-card' v-for="(payment, i) in payments" :key="i">
              <div class='ba-top'>
                  <span class='ba-title'>{{ payment.title }}</span>
                  <div class='ba-box-items ba-flex ba-gp-1'>
                      <span class='ba-badge ba-green' v-if="payment.status == 'PAID'" v-text="t.paid"></span>
                      <span class='ba-badge ba-red' v-else v-text="t.pending"></span>
                  </div>
              </div>
              <div style="width: 100%" class='ba-content ba-flex ba-jc-sb ba-ai-end ba-mg-t-1'>
                  <div>
                      <strong>{{t.date_payment}}:</strong> {{payment.date}}
                  </div>
                  <h4 class="ba-blue">{{`${payment.currency} ${payment.value}`}}</h4>
              </div>
          </div>

        </div>
        <div class='ba-card resources-container'>
          <div class='ba-top'>
              <span class='ba-title'>{{ t.resources }}</span>
          </div>
          <resources-quotas :resources="resources" v-if="resources.length > 0"/>
          <span v-else v-text="t.no_information_resources_on_period"></span>
        </div>
      </div>
    </builderall-loader>
  </div>
</template>

<script>
export default
{
    name: "invoices-billing-tab",
    props: ['translations'],
    data() {
      return {
        loading: false,
        payments: [],
        periods: ['0000-00'],
        period: null,
        resources: [],
        t: this.translations
      }
    },
    methods: {
      refresh () {
        this.loading = true;

        axios.get(`/${window.__env.locale}/office/billing?period=${this.period}`)
          .then((r) => {
            this.periods   = r.data.data.periods;
            this.payments  = r.data.data.payments;
            this.resources = r.data.data.resources;
          })
          .catch((err) => { console.error(err)})
          .finally(() => this.loading = false);
      },
      getCurrentPeriod () {
        var currentDate = new Date();
        return `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1).toString().padStart(2, '0')}`;
      },
      getStartingPeriod (){
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get('period') || this.getCurrentPeriod()
      },
      setPlaceholders () {
        this.periods   = ['0000-00'];
        this.resources = [{
                "title": "Domains",
                "slug": "domain",
                "type": "SIMPLE",
                "left": null,
                "right": "0 of 0",
                "current": 0,
                "limit": 0
            },
            {
                "title": "Hard drive Space",
                "slug": "storafe",
                "type": "DOUBLE",
                "left": "0 GB",
                "right": "0 GB",
                "current": 0,
                "limit": 0
            },
            {
                "title": "Subscribers",
                "slug": "mailingboss-subscribers",
                "type": "DOUBLE",
                "left": "0 of 0",
                "right": "0%",
                "current": 0,
                "limit": 0
            }
        ];
        this.payments  = [
            {
                "title": "Payment",
                "currency": "USD",
                "value": "0.00",
                "date": "0000-00-00",
                "status": "PAID"
            },
            {
                "title": "Payment",
                "currency": "USD",
                "value": "0.00",
                "date": "0000-00-00",
                "status": "PAID"
            },
            {
                "title": "Payment",
                "currency": "USD",
                "value": "0.00",
                "date": "0000-00-00",
                "status": "PAID"
            }];
      },
      print () {
        this.$parent.printReceiptType   = 'period';
        this.$parent.printNotifications = this.payments.map ((payment) => payment.notification_id);
        this.$parent.printReceiptPeriod = this.period;
        $("#modalReceipt").modal('show');
      },
      appendPeriodToUrl () {
          const newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?period=' + this.period;
          window.history.pushState({ path: newurl }, '', newurl);
      }
    },
    mounted () {
      this.setPlaceholders();
      this.period = this.getStartingPeriod();
    },
    watch: {
      period () {
        this.refresh();
        this.appendPeriodToUrl();
      }
    }
  }
</script>

<style scoped lang="scss">
  .invoces-container {
    width: 65%;
    padding-bottom: 200px;
  }

  .resources-container {
    width: 35%;
    height: fit-content;
  }

  h4 {
    font-size: 18px;
  }

  .card-period-not-closed {
    font-size: 15px;
    min-height: unset;

    .ba-top {
      .ba-title {
        font-size: 15px;
      }
      .ba-icon {
        width: 35px;
        height: 35px;

        builderall-icon {
          --builderall-icon-size: 25px;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// resources/office/js/components/invoices/BillingTab.vue